import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, permission, cfBlock = false }) {
  const { user, ready, hasPermission } = useAuth();
  const location = useLocation();

  if (!ready) {
    return (
      <div className="flex h-screen w-screen items-center justify-center text-sm text-zinc-500">
        Loading...
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (cfBlock && user.cf_team) {
    return <Navigate to="/daily-profit" replace />;
  }
  if (permission && !hasPermission(permission)) {
    return (
      <div className="p-10 text-sm text-zinc-600" data-testid="no-permission">
        You don't have access to this module. Contact the master admin.
      </div>
    );
  }
  return children;
}
